import { render, staticRenderFns } from "./FamilyActivityPendingEmails.vue?vue&type=template&id=4bdb2b37&scoped=true&"
import script from "./FamilyActivityPendingEmails.vue?vue&type=script&lang=ts&"
export * from "./FamilyActivityPendingEmails.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyActivityPendingEmails.vue?vue&type=style&index=0&id=4bdb2b37&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb2b37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
